import { render, staticRenderFns } from "./DashboardTotalUpdateCoupon.vue?vue&type=template&id=650eff8f&"
import script from "./DashboardTotalUpdateCoupon.vue?vue&type=script&lang=js&"
export * from "./DashboardTotalUpdateCoupon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports